import { useState, useEffect } from 'react'
import novidadesApiService from 'Services/api/novidades'

const useNovidades = () => {
  const [data, setData] = useState(null)
  const [hasError, setHasError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const fetchNovidades = async () => {
    setIsLoading(true)
    setHasError(false)

    try {
      const response = await novidadesApiService.list()
      if (response.data) {
        setData(response.data)
      } else {
        throw new Error('Dados inesperados recebidos da API')
      }
    } catch (error) {
      console.error('Erro ao buscar novidades:', error)
      setHasError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchNovidades()
  }, [])

  return {
    fetchNovidades,
    novidadesRequest: { data, hasError, isLoading }
  }
}

export default useNovidades
